import { useEffect } from "react";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";

import "../Swagger.css";
import { firebaseAuth } from "../configs/firebase";

const complete = function (swaggerUi: any) {
  firebaseAuth.currentUser
    ?.getIdToken()
    .then((t) => swaggerUi.preauthorizeApiKey("bearerAuth", t));
};

const ApiDocs = () => {
  useEffect(() => {
    document?.getElementById("root")?.classList.add("swagger-force-light-mode");
    return () => {
      document
        ?.getElementById("root")
        ?.classList.remove("swagger-force-light-mode");
    };
  }, []);

  return (
    <SwaggerUI url="/openapi.yaml" onComplete={complete} persistAuthorization />
  );
};

export default ApiDocs;
